import { Breadcrumbs, Typography } from '@mui/material';
import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Colors } from '../utils/Theme';

interface Props {
  breadcrumbs: { label: string; link: string; icon?: JSX.Element }[];
  headline: string;
  children?: JSX.Element;
}

export const SiteHeader: FC<Props> = ({ breadcrumbs, headline, children }) => {
  return (
    <>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => {
          return (
            <RouterLink
              key={index}
              to={breadcrumb.link}
              style={{
                color: Colors.BLACK_BLUE,
                textDecoration: 'none',
                alignItems: 'center',
                display: 'flex',
              }}
              onMouseOver={(e) => {
                (e.target as HTMLElement).style.textDecoration = 'underline';
              }}
              onMouseOut={(e) => {
                (e.target as HTMLElement).style.textDecoration = 'none';
              }}
            >
              {breadcrumb.icon}
              {breadcrumb.label}
            </RouterLink>
          );
        })}
      </Breadcrumbs>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 20,
          marginBottom: 20,
        }}
      >
        <Typography variant="h4">{headline}</Typography>
        {children}
      </div>
    </>
  );
};
